import React, { useState, useRef, useEffect } from "react";
import "./signUp.css";
import tvsLogo from "../../../assets/tvs-logo.png";
import InputField from "../../../components/inputField";
import CheckBox from "../../../components/checkBox";
import PrimaryButton from "../../../components/primaryButton";
import axios from "axios";
import arrowback from "../../../assets/u400c/arrow-left.png";
import { ConfigBaseUrl } from "../../../config";
import { setUserDetails } from "../../../redux/actions/user-details-action";
import { useDispatch } from "react-redux";
import CartWarning from "../components/addCartWarning";

const SignUp = ({ onUserAuth, setExpand, onConfigurator }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [nameErrorMsg, setNameErrorMsg] = useState("");
  const [mobileErrorMsg, setMobileErrorMsg] = useState("");
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [otpErrorMsg, setOtpErrorMsg] = useState("");
  const [checked, setChecked] = useState(false);

  const [timer, setTimer] = useState("00:00");
  const Ref = useRef(null);
  const [otpSent, setOtpSent] = useState(false);
  const [requestOtp, setRequestOtp] = useState(false);
  const [resendOtp, setResendOtp] = useState(true);
  const [loader, setLoader] = useState(false);

  const [cartWarningModal, setCartWarningModal] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    setExpand(false);
  }, []);

  function onToast(message, data) {
    setCartWarningModal(!cartWarningModal);
    setToastMessage(message);
    setTimeout(() => {
      setCartWarningModal(false);
      dispatch(setUserDetails(data?.Data[0]));
      onUserAuth("token");
    }, 2000);
  }

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    return {
      total,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      setTimer(
        (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
    }
  };

  const clearTimer = (e) => {
    setTimer("01:30");
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  const getDeadTime = () => {
    let deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + 90);
    return deadline;
  };

  const onRequestOtp = () => {
    try {
      setLoader(true);
      setErrorMsg("");

      let emailErrorMessage = "";
      const regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
      if (email) {
        if (!regEmail.test(email)) {
          emailErrorMessage = "The format of your email is incorrect.";
        }
      } else {
        emailErrorMessage = "Please enter email address.";
      }
      setEmailErrorMsg(emailErrorMessage);
      const emailValidate = regEmail.test(email);

      //////////////

      let mobileErrorMessage = "";
      const regMobile = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (mobile) {
        if (!regMobile.test(mobile)) {
          mobileErrorMessage = "Please enter valid mobile number.";
        }
      } else {
        mobileErrorMessage = "Please enter mobile number.";
      }
      setMobileErrorMsg(mobileErrorMessage);
      const mobileValidate = regMobile.test(mobile);

      if (
        name.length === 0 ||
        emailValidate === false ||
        mobileValidate === false
      ) {
        if (name.length === 0) {
          setNameErrorMsg("Please enter your name.");
        } else {
          setNameErrorMsg("");
        }
      } else {
        setErrorMsg("");
        setNameErrorMsg("");
        setMobileErrorMsg("");
        setEmailErrorMsg("");
        setOtpErrorMsg("");
        axios({
          method: "post",
          url: ConfigBaseUrl() + "register-create-user",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {
            FullName: name,
            MobileNumber: mobile,
            Email: email,
          },
        })
          .then((res) => {
            const data = res.data;
            if (data?.StatusCode === 200) {
              setOtpSent(true);
              clearTimer(getDeadTime());
              setResendOtp(false);
              setLoader(false);
            } else {
              setErrorMsg(data?.Message);

              setLoader(false);
            }
          })
          .catch((error) => {
            console.error("Request failed with status code 500:", error);

            // Handle the error here, you can set an appropriate error message or take other actions.
            setErrorMsg("An error occurred while processing your request.");
            setLoader(false);
          });
      }
    } catch (error) {
      console.error("Request failed with status code 500:", error);

      // Handle the error here, you can set an appropriate error message or take other actions.
      setErrorMsg("An error occurred while processing your request.");
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const onResendOtp = () => {
    try {
      setLoader(true);

      setErrorMsg("");

      let mobileErrorMessage = "";
      const regMobile = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (mobile) {
        if (!regMobile.test(mobile)) {
          mobileErrorMessage = "Please enter valid mobile number.";
        }
      } else {
        mobileErrorMessage = "Please enter mobile number.";
      }
      setMobileErrorMsg(mobileErrorMessage);
      const mobileValidate = regMobile.test(mobile);

      if (mobileValidate === true) {
        setErrorMsg("");
        setNameErrorMsg("");
        setMobileErrorMsg("");
        setEmailErrorMsg("");
        setOtpErrorMsg("");
        axios({
          method: "post",
          url: ConfigBaseUrl() + "register-generate-otp",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {
            MobileNumber: mobile,
          },
        })
          .then((res) => {
            const data = res.data;
            if (data?.StatusCode === 200) {
              setOtpSent(true);
              clearTimer(getDeadTime());
              setResendOtp(false);
              setLoader(false);
            } else {
              setErrorMsg(data?.Message);

              setLoader(false);
            }
          })
          .catch((error) => {
            console.error("Request failed with status code 500:", error);

            // Handle the error here, you can set an appropriate error message or take other actions.
            setErrorMsg("An error occurred while processing your request.");
            setLoader(false);
          });
      }
    } catch (error) {
      console.error("Request failed with status code 500:", error);

      // Handle the error here, you can set an appropriate error message or take other actions.
      setErrorMsg("An error occurred while processing your request.");
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const onVerifyOtp = () => {
    try {
      let emailErrorMessage = "";
      const regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
      if (email) {
        if (!regEmail.test(email)) {
          emailErrorMessage = "The format of your email is incorrect.";
        }
      } else {
        emailErrorMessage = "Please enter email address.";
      }
      setEmailErrorMsg(emailErrorMessage);
      const emailValidate = regEmail.test(email);

      //////////////

      let mobileErrorMessage = "";
      const regMobile = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (mobile) {
        if (!regMobile.test(mobile)) {
          mobileErrorMessage = "Please enter valid mobile number.";
        }
      } else {
        mobileErrorMessage = "Please enter mobile number.";
      }
      setMobileErrorMsg(mobileErrorMessage);
      const mobileValidate = regMobile.test(mobile);

      if (
        name.length === 0 ||
        emailValidate === false ||
        mobileValidate === false
      ) {
        if (name.length === 0) {
          setNameErrorMsg("Please enter your name.");
        } else {
          setNameErrorMsg("");
        }
      } else if (otp.length === 0) {
        setOtpErrorMsg("Please enter OTP.");

        setNameErrorMsg("");
        setMobileErrorMsg("");
        setEmailErrorMsg("");
      } else if (!checked) {
        setErrorMsg("Please accept the terms & conditions");
      } else {
        setErrorMsg("");
        setNameErrorMsg("");
        setMobileErrorMsg("");
        setEmailErrorMsg("");
        setOtpErrorMsg("");
        setLoader(true);

        axios({
          method: "post",
          url: ConfigBaseUrl() + "register-verify-otp",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {
            mobileNumber: mobile,
            otp: otp,
            iosToken: "",
            androidToken: "",
          },
        })
          .then((res) => {
            const data = res.data;

            if (data?.StatusCode === 200) {
              onToast("You have registered successfully.", data);
              // sessionStorage.setItem(
              //   "token",
              //   JSON.stringify(data?.Data[0]?.Token)
              // );
              // sessionStorage.setItem("userDetails", JSON.stringify(data?.Data));
              // dispatch(setUserDetails(data?.Data[0]));
              // onUserAuth("token");
              setLoader(false);
            } else {
              setErrorMsg(data?.Message);

              setLoader(false);
            }
          })
          .catch((error) => {
            console.error("Request failed with status code 500:", error);

            // Handle the error here, you can set an appropriate error message or take other actions.
            setErrorMsg("An error occurred while processing your request.");
            setLoader(false);
          });
      }
    } catch (error) {
      console.error("Request failed with status code 500:", error);

      // Handle the error here, you can set an appropriate error message or take other actions.
      setErrorMsg("An error occurred while processing your request.");
      setLoader(false);
    } finally {
      // setLoader(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onVerifyOtp();
  };

  return (
    <>
      {/* <ExpandIcon fullScreen={fullScreen} setExpand={setExpand} /> */}
      <div className="signup_page_container">
        <form onSubmit={handleSubmit}>
          <div className="signup_container">
            <img src={tvsLogo} className="logo" />
            <div className="signup_header">New User? Sign Up</div>
            <div className="label_text required">All ﬁelds are mandatory</div>

            {cartWarningModal && (
              <div className="label_text2">
                <CartWarning
                  setCartWarningModal={setCartWarningModal}
                  cartWarningModal={cartWarningModal}
                  toastMessage={toastMessage}
                  setToastMessage={setToastMessage}
                />
              </div>
            )}
            <InputField
              placeholder={"Full Name"}
              value={name}
              onChange={(e) => setName(e)}
              errorMsg={nameErrorMsg}
            />

            <InputField
              placeholder={"Email ID"}
              value={email}
              onChange={(e) => setEmail(e.replace(" ", ""))}
              errorMsg={emailErrorMsg}
            />
            <InputField
              placeholder={"Mobile Number"}
              value={mobile}
              onChange={(e) => setMobile(e.replace(" ", ""))}
              label={"Request OTP"}
              onPress={() => {
                onRequestOtp();
                setRequestOtp(true);
              }}
              errorMsg={mobileErrorMsg}
              otpSent={otpSent}
              request={requestOtp}
              loader={loader}
            />
            <InputField
              placeholder={"Enter OTP"}
              value={otp}
              onChange={(e) => setOtp(e.replace(" ", ""))}
              label={"Resend OTP"}
              onPress={() => {
                onResendOtp();
                setResendOtp(false);
              }}
              errorMsg={otpErrorMsg}
              timer={timer}
              otpSent={otpSent}
              resend={resendOtp}
              loader={loader}
            />
            <CheckBox
              label="I accept the terms & conditions and authorise TVS Motor Company to
        contact me via SMS, email, WhatsApp and other modes of communication."
              onChange={(value) => setChecked(value)}
            />
            {errorMsg && <div className="error_msg">{errorMsg}</div>}
            <PrimaryButton
              label={"SUBMIT"}
              isSubmit={true}
              loading={loader}
              className="view_btn"
              size="small"
              // onClick={() => {
              //   onVerifyOtp();
              // }}
            />
            <div className="existing_user">
              Already have an account?{" "}
              <span onClick={() => onUserAuth("signin")}>Sign in</span>
            </div>
            <div
              className="on_back"
              style={{ top: "0.07rem" }}
              onClick={() => {
                onConfigurator(0);
              }}
            >
              <img src={arrowback} alt="back"></img>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default SignUp;
